module.exports = __webpack_public_path__ + "img/course-no.f1e79d36.png";